export default __webpack_public_path__ + "static/media/fun_may2020_pt2.ef577bf3.bmp";